import AmexColor from '../../../assets/images/brands/medium-colors/American_Express_Color.svg';
import BBVAColor from '../../../assets/images/brands/medium-colors/BBVA_Color_On.svg';
import BimoColor from '../../../assets/images/brands/medium-colors/Bimo_Color.svg';
import BNAColor from '../../../assets/images/brands/medium-colors/BNA_Color.svg';
import BrubankColor from '../../../assets/images/brands/medium-colors/Brubank_Color.svg';
import CabalColor from '../../../assets/images/brands/medium-colors/Cabal_Color.svg';
import CabalDebitoColor from '../../../assets/images/brands/medium-colors/Cabal_Debito_Color.svg';
import CuentaDNIColor from '../../../assets/images/brands/medium-colors/Cuenta_DNI_Color.svg';
import MaestroColor from '../../../assets/images/brands/medium-colors/Maestro_Color.svg';
import MasterCardColor from '../../../assets/images/brands/medium-colors/Mastercard_Color.svg';
import MasterCardDebitoColor from '../../../assets/images/brands/medium-colors/Mastercard_Debito_Color.svg';
import ModoColor from '../../../assets/images/brands/medium-colors/Modo_Color.svg';
import NaranjaColor from '../../../assets/images/brands/medium-colors/Naranja_Color.svg';
import NoneColor from '../../../assets/images/brands/medium-colors/None_Color.svg';
import TodoPagoColor from '../../../assets/images/brands/medium-colors/Todopago_Color.svg';
import UnionPayColor from '../../../assets/images/brands/medium-colors/Unionpay_Color.svg';
import VisaColor from '../../../assets/images/brands/medium-colors/Visa_Color.svg';
import VisaDebitoColor from '../../../assets/images/brands/medium-colors/Visa_Debito_Color.svg';
import AmexGray from '../../../assets/images/brands/medium-gray/American_Express_Gray.svg';
import BBVAGray from '../../../assets/images/brands/medium-gray/BBVA_Gray.svg';
import BimoGray from '../../../assets/images/brands/medium-gray/Bimo_Gray.svg';
import BNAGray from '../../../assets/images/brands/medium-gray/BNA_Gray.svg';
import BrubankGray from '../../../assets/images/brands/medium-gray/Brubank_Gray.svg';
import CabalGray from '../../../assets/images/brands/medium-gray/Cabal_Gray.svg';
import CabalDebitoGray from '../../../assets/images/brands/medium-gray/Cabal_Debito_Gray.svg';
import CuentaDNIGray from '../../../assets/images/brands/medium-gray/Cuenta_DNI_Gray.svg';
import MaestroGray from '../../../assets/images/brands/medium-gray/Maestro_Gray.svg';
import MasterCardGray from '../../../assets/images/brands/medium-gray/Mastercard_Gray.svg';
import MasterCardDebitoGray from '../../../assets/images/brands/medium-gray/Mastercard_Debito_Gray.svg';
import ModoGray from '../../../assets/images/brands/medium-gray/Modo_Gray.svg';
import NaranjaGray from '../../../assets/images/brands/medium-gray/Naranja_Gray.svg';
import NoneGray from '../../../assets/images/brands/medium-gray/None_Gray.svg';
import TodoPagoGray from '../../../assets/images/brands/medium-gray/Todopago_Gray.svg';
import UnionPayGray from '../../../assets/images/brands/medium-gray/Unionpay_Gray.svg';
import VisaGray from '../../../assets/images/brands/medium-gray/Visa_Gray.svg';
import VisaDebitoGray from '../../../assets/images/brands/medium-gray/Visa_Debito_Gray.svg';
import MercadoPagoGray from '../../../assets/images/brands/medium-gray/Mercado_Pago_Gray.svg';
import MercadoPagoColor from '../../../assets/images/brands/medium-colors/Mercado_Pago_Color.svg';
import AnkColor from '../../../assets/images/brands/medium-colors/Ank_Color.svg';
import AnkGray from '../../../assets/images/brands/medium-gray/Ank_Gray.svg';
import InstantPaymentColor from '../../../assets/images/brands/medium-colors/Instant_Payment_Color.svg';
import InstantPaymentGray from '../../../assets/images/brands/medium-gray/Instant_Payment_Gray.svg';
import DiscoverColor from '../../../assets/images/brands/medium-colors/Discover_Color.svg';
import DiscoverGray from '../../../assets/images/brands/medium-gray/Discover_Gray.svg';
import NaranjaXColor from '../../../assets/images/brands/medium-colors/NaranjaX_Color.svg';
import NaranjaXGray from '../../../assets/images/brands/medium-gray/NaranjaX_Gray.svg';
import VisaPrepaidColor from '../../../assets/images/brands/medium-colors/Visa_Prepaga.svg';
import MastercardPrepaidColor from '../../../assets/images/brands/medium-colors/Mastercard_Prepaga.svg';

export const BrandAssets = {
  amex_color: AmexColor,
  bbva_color: BBVAColor,
  bimo_color: BimoColor,
  bna_color: BNAColor,
  brubank_color: BrubankColor,
  cabal_color: CabalColor,
  cabal_debito_color: CabalDebitoColor,
  cuenta_dni_color: CuentaDNIColor,
  maestro_color: MaestroColor,
  mastercard_color: MasterCardColor,
  mastercard_debito_color: MasterCardDebitoColor,
  modo_color: ModoColor,
  naranja_color: NaranjaColor,
  naranjax_color: NaranjaXColor,
  none_color: NoneColor,
  todopago_color: TodoPagoColor,
  unionpay_color: UnionPayColor,
  visa_color: VisaColor,
  visa_debito_color: VisaDebitoColor,
  amex_gray: AmexGray,
  bbva_gray: BBVAGray,
  bimo_gray: BimoGray,
  bna_gray: BNAGray,
  brubank_gray: BrubankGray,
  cabal_gray: CabalGray,
  cabal_debito_gray: CabalDebitoGray,
  cuenta_dni_gray: CuentaDNIGray,
  maestro_gray: MaestroGray,
  mastercard_gray: MasterCardGray,
  mastercard_debito_gray: MasterCardDebitoGray,
  modo_gray: ModoGray,
  naranja_gray: NaranjaGray,
  naranjax_gray: NaranjaXGray,
  none_gray: NoneGray,
  todopago_gray: TodoPagoGray,
  unionpay_gray: UnionPayGray,
  visa_gray: VisaGray,
  visa_debito_gray: VisaDebitoGray,
  mercado_pago_gray: MercadoPagoGray,
  mercado_pago_color: MercadoPagoColor,
  ank_color: AnkColor,
  ank_gray: AnkGray,
  instant_payment_color: InstantPaymentColor,
  instant_payment_gray: InstantPaymentGray,
  discover_gray: DiscoverGray,
  discover_color: DiscoverColor,
  visa_prepaid_color: VisaPrepaidColor,
  mastercard_prepaid_color: MastercardPrepaidColor,
};
